module.exports = __webpack_public_path__ + "img/smeup.d99e25ee.png";